import { RootState } from 'data/store/store';

export const NAME = 'data/HOME_MIX';
export const LOAD_HOME_MIX_SETTINGS = `${NAME}/LOAD`;
export const SET_HOME_MIX_SETTINGS = `${NAME}/SET`;
export const RESET_HOME_MIX_SETTINGS = `${NAME}/RESET`;
export const UPDATE_HOME_MIX_SETTINGS = `${NAME}/UPDATE`;
export const SET_ERROR_LOADING_SETTINGS = `${NAME}/ERROR_LOADING`;

export type HomeMixSettings = {
  enabled: boolean;
  publishExplicit: boolean;
  blacklistArtist: Array<string>;
  blacklistGenre: Array<string>;
  blacklistTrack: Array<string>;
};

export type HomeMixState = {
  homeMixSettings: HomeMixSettings | null;
  errorLoadingHomeMixSettings: boolean;
  isLoadingHomeMixSettings: boolean;
  isUpdatingHomeMixSettings: boolean;
};

export const initialState: HomeMixState = {
  homeMixSettings: null,
  errorLoadingHomeMixSettings: false,
  isLoadingHomeMixSettings: true,
  isUpdatingHomeMixSettings: false,
};

type LoadHomeMixSettingsAction = {
  type: typeof LOAD_HOME_MIX_SETTINGS;
};

export const loadHomeMixSettings = (): LoadHomeMixSettingsAction => ({
  type: LOAD_HOME_MIX_SETTINGS,
});

type UpdateHomeMixSettingsAction = {
  type: typeof UPDATE_HOME_MIX_SETTINGS;
};

export const updateHomeMixSettings = (): UpdateHomeMixSettingsAction => ({
  type: UPDATE_HOME_MIX_SETTINGS,
});

type SetHomeMixSettingsAction = {
  type: typeof SET_HOME_MIX_SETTINGS;
  data: HomeMixSettings;
};

export const setHomeMixSettings = (
  settings: HomeMixSettings,
): SetHomeMixSettingsAction => ({
  type: SET_HOME_MIX_SETTINGS,
  data: settings,
});

type ResetHomeMixSettingsAction = {
  type: typeof RESET_HOME_MIX_SETTINGS;
};

export const resetHomeMixSettings = (): ResetHomeMixSettingsAction => ({
  type: RESET_HOME_MIX_SETTINGS,
});

type SetErrorLoadingSettingsAction = {
  type: typeof SET_ERROR_LOADING_SETTINGS;
};

export const setErrorLoadingSettings = (): SetErrorLoadingSettingsAction => ({
  type: SET_ERROR_LOADING_SETTINGS,
});

type HomeMixActionTypes =
  | LoadHomeMixSettingsAction
  | SetHomeMixSettingsAction
  | ResetHomeMixSettingsAction
  | UpdateHomeMixSettingsAction
  | SetErrorLoadingSettingsAction;

export const reducer = (state = initialState, action: HomeMixActionTypes) => {
  switch (action.type) {
    case LOAD_HOME_MIX_SETTINGS:
      return {
        ...state,
        isLoadingHomeMixSettings: true,
      };
    case SET_HOME_MIX_SETTINGS:
      return {
        ...state,
        homeMixSettings: (action as SetHomeMixSettingsAction).data,
        isLoadingHomeMixSettings: false,
        isUpdatingHomeMixSettings: false,
      };
    case RESET_HOME_MIX_SETTINGS:
      return {
        ...state,
        isLoadingHomeMixSettings: false,
        isUpdatingHomeMixSettings: false,
      };
    case UPDATE_HOME_MIX_SETTINGS:
      return {
        ...state,
        isUpdatingHomeMixSettings: true,
      };
    case SET_ERROR_LOADING_SETTINGS:
      return {
        ...state,
        errorLoadingHomeMixSettings: true,
        isLoadingHomeMixSettings: false,
        isUpdatingHomeMixSettings: false,
      };
    default:
      return state;
  }
};

export const selector = (state: RootState) => state[NAME];
